import apiConfig from './apiConfig';
import interiorImage from './interiorImage';
import {socialImage} from './social';

export default {
    apiHost: apiConfig.host,
    waitBeforePolling: 4,
    pollingTime: 120,
    pollingSleep: 2,
    contactEmail: 'hello@yourlovely.place',
    privacyPolicyUrl: '/privacy-policy',
    termsOfUseUrl: '/terms-of-service',
    cookiePolicyUrl: '/cookie-policy',
    legalSeller: {name: '', address: '', country: '', registration: ''},
    instagramUrl: 'https://www.instagram.com/yourlovely.place/',
    tiktokUrl: 'https://tiktok.com/@yourlovely.place',
    pinterestUrl: 'https://www.pinterest.com/YourLovelyPlace/',
    homeUrl: 'https://yourlovely.place/',
    domain: 'yourlovely.place',
    metaImage: socialImage.url,
    title: 'YourLovely.Place',
    backgroundImageUrl: interiorImage.src,
    gtmId: 'GTM-TFXLXKH',
    yandexMetrikaId: 93502551,
};
